/** @type {import("../../../../shared/ui/data-table/model/data-table-contract").UnifiedTableRecord[]} */
export const encounters = [
  {
    patientId: "11",
    module: "encounters",
    pageTitle: "Encounters",

    subnav: [],

    sections: [
      {
        id: "encounters",
        title: "Encounters",
        tables: [
          {
            id: "encounters-main",
            columns: [
              { key: "encCode", header: "Enc Code", sortable: true },
              { key: "visitType", header: "Visit Type" },
              { key: "encDate", header: "Enc Date" },
              { key: "encDiagnosis", header: "Enc Diagnosis" },
              { key: "provider", header: "Provider" },
              {
                key: "encDetails",
                header: "Details",
                rendererId: "encDetails",
              },
              {
                key: "encLabsProcedures",
                header: "",
                rendererId: "encLabsProcedures",
              },
              { key: "encBilling", header: "", rendererId: "encBilling" },
              {
                key: "encScannedDocs",
                header: "",
                rendererId: "encScannedDocs",
              },
              { key: "patientMessage", header: "Patient Message" },
            ],
            rows: [
              {
                encCode: "292928",
                visitType: "Physical Therapy Treatment",
                encDate: "12/05/2017",
                encDiagnosis:
                  "S/P lumbar fusion (Z98.1), Low back pain, unspecified back pain laterality, unspecified chronicity, with sciatica presence unspecified (M54.5)",
                provider: "Testa, Nicholas",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "-",
              },
              {
                encCode: "292929",
                visitType: "Physical Therapy Treatment",
                encDate: "11/30/2017",
                encDiagnosis:
                  "S/P lumbar fusion (Z98.1), Low back pain, unspecified back pain laterality, unspecified chronicity, with sciatica presence unspecified (M54.5)",
                provider: "Cusumano, Chris",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "-",
              },
              {
                encCode: "292930",
                visitType: "Physical Therapy Treatment",
                encDate: "11/25/2017",
                encDiagnosis: "Low back pain, episodic",
                provider: "Doe, John",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "-",
              },
              {
                encCode: "292931",
                visitType: "Physical Therapy Treatment",
                encDate: "11/20/2017",
                encDiagnosis: "Left hip pain",
                provider: "Smith, Jane",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "-",
              },
              {
                encCode: "292932",
                visitType: "Physical Therapy Treatment",
                encDate: "11/15/2017",
                encDiagnosis: "Hypertension",
                provider: "Brown, Alice",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "-",
              },
              {
                encCode: "292933",
                visitType: "Physical Therapy Treatment",
                encDate: "11/10/2017",
                encDiagnosis: "Hyperlipidemia",
                provider: "Green, Emily",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "-",
              },
              {
                encCode: "292934",
                visitType: "Physical Therapy Treatment",
                encDate: "11/05/2017",
                encDiagnosis: "HTN (hypertension)",
                provider: "White, Michael",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "-",
              },
              {
                encCode: "292935",
                visitType: "Physical Therapy Treatment",
                encDate: "11/01/2017",
                encDiagnosis: "Back Injury",
                provider: "Taylor, James",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "-",
              },
              {
                encCode: "292936",
                visitType: "Office Visit",
                encDate: "10/27/2017",
                encDiagnosis: "Type 2 diabetes mellitus without complications",
                provider: "Miller, Sarah",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "Follow up requested",
              },
              {
                encCode: "292937",
                visitType: "Lab Only",
                encDate: "10/20/2017",
                encDiagnosis: "Long term current use of medication",
                provider: "Patel, Aaron",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "-",
              },
              {
                encCode: "292938",
                visitType: "Telehealth",
                encDate: "10/12/2017",
                encDiagnosis: "Medication review",
                provider: "Nguyen, Lisa",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "Reviewed care plan",
              },
              {
                encCode: "292939",
                visitType: "Emergency Department",
                encDate: "09/30/2017",
                encDiagnosis: "Acute low back pain",
                provider: "Evans, Mark",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "-",
              },
              {
                encCode: "292940",
                visitType: "Radiology",
                encDate: "09/22/2017",
                encDiagnosis: "Lumbar radiculopathy",
                provider: "Chen, Grace",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "Imaging completed",
              },
              {
                encCode: "292941",
                visitType: "Physical Therapy Evaluation",
                encDate: "09/14/2017",
                encDiagnosis: "Postoperative rehabilitation",
                provider: "Roberts, Brian",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "-",
              },
              {
                encCode: "292935",
                visitType: "Physical Therapy Treatment",
                encDate: "11/01/2017",
                encDiagnosis: "Back Injury",
                provider: "Taylor, James",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "-",
              },
              {
                encCode: "292935",
                visitType: "Physical Therapy Treatment",
                encDate: "11/01/2017",
                encDiagnosis: "Back Injury",
                provider: "Taylor, James",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "-",
              },
              {
                encCode: "292935",
                visitType: "Physical Therapy Treatment",
                encDate: "11/01/2017",
                encDiagnosis: "Back Injury",
                provider: "Taylor, James",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "-",
              },
              {
                encCode: "292935",
                visitType: "Physical Therapy Treatment",
                encDate: "11/01/2017",
                encDiagnosis: "Back Injury",
                provider: "Taylor, James",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "-",
              },
              {
                encCode: "292935",
                visitType: "Physical Therapy Treatment",
                encDate: "11/01/2017",
                encDiagnosis: "Back Injury",
                provider: "Taylor, James",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "-",
              },
              {
                encCode: "292935",
                visitType: "Physical Therapy Treatment",
                encDate: "11/01/2017",
                encDiagnosis: "Back Injury",
                provider: "Taylor, James",
                encDetails: "History & Physical Report",
                encLabsProcedures: "Labs & Procedures",
                encBilling: "Billing Information",
                encScannedDocs: "Scanned Documents",
                patientMessage: "-",
              },
            ],
            ui: {
              searchable: true,
              searchPlaceholder: "Search...",
              searchKeys: [
                "encCode",
                "visitType",
                "encDate",
                "encDiagnosis",
                "provider",
                "patientMessage",
              ],
              downloadable: ["csv", "xls", "pdf"],
              downloadLinks: {
                csv: "https://drive.google.com/uc?export=download&id=1f-_X9g_ByD5VZqecjZiI4w_VbFS2cALF",
                pdf: "https://drive.google.com/uc?export=download&id=1d6eTMotUXVYBkWmP7N80A3JR9B2vS9K_",
                xls: "https://docs.google.com/spreadsheets/d/1W4ELK6wiHdAy6LwWQfKde09I0wTCAlk2/export?format=xlsx",
              },
              defaultRowsPerPage: 10,
              rowsPerPageOptions: [5, 10, 20, 25],
            },
          },
        ],
      },
    ],
  },
];
